const FORM_ENDPOINT = process.env.REACT_APP_FORM_ENDPOINT;
const DEFAULT_RECIPIENT = process.env.REACT_APP_CONTACT_EMAIL || 'hello@dalytix.com';

const buildMailto = (formType, data) => {
  const subject = encodeURIComponent(`Dalytix ${formType} inquiry`);
  const body = encodeURIComponent(
    Object.entries(data)
      .filter(([, value]) => value !== undefined && value !== null && value !== '')
      .map(([key, value]) => `${key}: ${value}`)
      .join('\n')
  );
  return `mailto:${DEFAULT_RECIPIENT}?subject=${subject}&body=${body}`;
};

export async function submitForm(formType, data) {
  if (data.website) {
    return { ok: true, spam: true };
  }

  if (!FORM_ENDPOINT) {
    window.location.href = buildMailto(formType, data);
    return { ok: true, fallback: true };
  }

  const response = await fetch(FORM_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      formType,
      submittedAt: new Date().toISOString(),
      ...data,
    }),
  });

  if (!response.ok) {
    throw new Error('We could not submit the form. Please email hello@dalytix.com directly.');
  }

  return { ok: true };
}
